import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { useSelector } from 'react-redux'
import { RootState } from '../store'

export enum RenderMode {
    Display = "display",
    EditFight = "editStructure",
    EditAssignments = "editAssignments",
    EditRoster = "editRoster",
}

type AppState = {
    outOfDateData: boolean
    renderMode: RenderMode
}

const initialState: AppState = {
    outOfDateData: false,
    renderMode: RenderMode.Display,
}

export const slice = createSlice({
    name: "app",
    initialState,
    reducers: {

        setRenderMode: (state, action: PayloadAction<{ renderMode: RenderMode }>) => {
            state.renderMode = action.payload.renderMode
        },

    }

})

export const AppActions = slice.actions
export const AppReducer = slice.reducer
export const useAppState = () => useSelector<RootState, AppState>(state => state.app)
